// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowLeftOutlinedSvg from "@fishx/icons-svg/es/asn/ArrowLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var ArrowLeftOutlined = function ArrowLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowLeftOutlinedSvg
  }));
};

ArrowLeftOutlined.displayName = 'ArrowLeftOutlined';
export default React.forwardRef(ArrowLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ArrowLeftOutlined.js
// module id = 2015
// module chunks = 0